import type { GetCompetencyProfilesRes } from 'shared-types/responses';
import type { MergedCompetency } from './getMergedCompetencies';

const getNumberOfMatchingCompetencies = ({
  competencies,
  userCompetencies
}: {
  competencies: GetCompetencyProfilesRes['competencyProfiles'][0]['competencies'];
  userCompetencies: MergedCompetency[];
}) =>
  competencies?.filter((competency) =>
    userCompetencies.some(
      (userCompetency) =>
        competency.id === userCompetency.id &&
        ((!competency.level?.id && !userCompetency.level?.id) ||
          userCompetency.highestLevel?.level >= competency.level?.level)
    )
  )?.length || 0;

export default getNumberOfMatchingCompetencies;
